/**
 * Featured product landing gallery: thumbnail → main image, rail scroll.
 * Does not depend on theme.Product (landing sections often omit the product form).
 */
(function () {
  var ACTIVE = 'active-thumb';
  var HIDDEN = 'hide';

  function getVisibleMediaId(section) {
    var visible = section.querySelector(
      '[data-product-single-media-wrapper]:not(.' + HIDDEN + ')'
    );
    return visible ? visible.getAttribute('data-media-id') : null;
  }

  function setActiveThumbLinks(section, mediaId) {
    section.querySelectorAll('[data-thumbnail-id]').forEach(function (link) {
      var id = link.getAttribute('data-thumbnail-id');
      var isActive = id === mediaId;
      link.classList.toggle(ACTIVE, isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function switchMedia(section, mediaId) {
    var wrappers = section.querySelectorAll('[data-product-single-media-wrapper]');
    wrappers.forEach(function (w) {
      var id = w.getAttribute('data-media-id');
      if (id === mediaId) {
        w.classList.remove(HIDDEN);
        w.dispatchEvent(
          new CustomEvent('mediaVisible', { bubbles: true, cancelable: true })
        );
      } else {
        w.classList.add(HIDDEN);
        w.dispatchEvent(
          new CustomEvent('mediaHidden', { bubbles: true, cancelable: true })
        );
      }
    });
    setActiveThumbLinks(section, mediaId);
  }

  function scrollRailToThumb(section, thumbLink) {
    var rail = section.querySelector('.landing-thumbnails-rail[data-slider-container]');
    if (!rail || !thumbLink) return;
    var item = thumbLink.closest('[data-slider-item]');
    if (!item) return;
    var railRect = rail.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var nextLeft =
      rail.scrollLeft +
      (itemRect.left - railRect.left) -
      (rail.clientWidth - itemRect.width) / 2;
    rail.scrollTo({
      left: Math.max(0, nextLeft),
      behavior: 'smooth'
    });
  }

  function scrollStep(rail, direction) {
    var step = rail.clientWidth * 0.85;
    rail.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  function bindThumbnailClicks(section) {
    section.addEventListener('click', function (e) {
      var link = e.target.closest('[data-thumbnail-id]');
      if (!link || !section.contains(link)) return;
      e.preventDefault();
      var mediaId = link.getAttribute('data-thumbnail-id');
      if (!mediaId) return;
      switchMedia(section, mediaId);
      scrollRailToThumb(section, link);
    });
  }

  function bindNavButtons(section, sectionId) {
    var rail = section.querySelector('.landing-thumbnails-rail[data-slider-container]');
    if (!rail) return;
    var prev = section.querySelector('.thumbnails-slider__prev--' + sectionId);
    var next = section.querySelector('.thumbnails-slider__next--' + sectionId);
    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        scrollStep(rail, -1);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        scrollStep(rail, 1);
      });
    }
  }

  function initLandingGallery(section) {
    if (section.getAttribute('data-landing-gallery-bound') === 'true') return;
    section.setAttribute('data-landing-gallery-bound', 'true');

    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    var initial = getVisibleMediaId(section);
    if (initial) {
      setActiveThumbLinks(section, initial);
    }

    bindThumbnailClicks(section);
    bindNavButtons(section, sectionId);
  }

  function scan() {
    document.querySelectorAll('[data-landing-product-gallery]').forEach(initLandingGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"][data-landing-product-gallery]'
    );
    if (container) {
      container.removeAttribute('data-landing-gallery-bound');
      initLandingGallery(container);
    }
  });
})();
